// extracted by mini-css-extract-plugin
module.exports = {"header":"vk52V_","container":"mzTLQe","content":"tg5ULB","note":"lKOUlo","link":"e5QjIH","fact":"_4AVU5E","currency":"tcBH7a","highlitedtext":"agnbod"};